import VueRouter from 'vue-router';
import auth from './auth';
import analytics from './analytics';

export default function decorate(router: VueRouter) {
  auth(router);
  analytics(router);
}
